import { useLazyQuery } from '@apollo/client/react';
import { STAFF_POWERBI_VERIFY } from '@staff-app/graphql-client';

export type StepOutcome = 'success' | 'failed' | 'blocked';

/** One verification step as returned by staffPowerbiVerify. */
export interface PowerbiStep {
  outcome: StepOutcome;
  requestUrl?: string | null;
  httpStatus?: number | null;
  durationMs?: number | null;
  token?: string | null;
  groupId?: string | null;
  reportId?: string | null;
  htmlPreview?: string | null;
  headersJson?: string | null;
  error?: string | null;
  raw?: string | null;
}

export interface PowerbiVerifyResult {
  accessToken: PowerbiStep;
  // Early-exit: null when the prior step didn't succeed.
  embedToken?: PowerbiStep | null;
  reportHtml?: PowerbiStep | null;
}

export type PowerbiVerifyVars = {
  reportUrl: string;
  clientId: string;
  clientSecret: string;
  tenantId: string;
};

/**
 * Power BI auth verification — runs the 3-step diagnostic server-side
 * (staffPowerbiVerify) and returns per-step results. Lazy: triggered on
 * "Run Troubleshooting". `network-only` so each run is fresh (never cached —
 * the inputs include a secret).
 */
export function usePowerbiVerify() {
  return useLazyQuery<{ staffPowerbiVerify: PowerbiVerifyResult }, PowerbiVerifyVars>(
    STAFF_POWERBI_VERIFY,
    { fetchPolicy: 'network-only' },
  );
}
